import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "./styles.scss";

// Sections
import { Hero, Atletica } from "./sections";
import Scoutify from "./sections/Scoutify";
import { ScoutifyMobile } from "./sections/Scoutify";
import Immotech from "./sections/Immotech";
import { ImmotechMobile } from "./sections/Immotech";
import Amarant from "./sections/Amarant";
import EnRPi from "./sections/EnRPi";
import Insurance from "./sections/Insurance";
import FightScout from "./sections/FightScout";
import About from "./sections/About";

// Wave decoration (spans across ERP and Atletica sections)
const waveDecoration = "/2025/hero/images/wave.svg";

export function Christmas2025() {
  const [isMobile, setIsMobile] = useState(false);

  // Enable scrolling on this page (body has overflow:hidden globally)
  useEffect(() => {
    document.body.style.overflow = "auto";
    document.body.style.overflowX = "hidden";
    
    // Check for mobile/tablet
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    // Cleanup - restore original overflow when leaving the page
    return () => {
      document.body.style.overflow = "hidden";
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Fidweb 2025 - Our Projects Showcase</title>
        <meta name="description" content="Discover Fidweb's 2025 portfolio: Atletica Sports, Scoutify, Immotech, Amarant, EnRPi, Insurance solutions, and FightScout. Making software people actually love." />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://fidweb.net/2025" />
        <meta property="og:title" content="Fidweb 2025 - Our Projects Showcase" />
        <meta property="og:description" content="Discover Fidweb's 2025 portfolio: Atletica Sports, Scoutify, Immotech, Amarant, EnRPi, Insurance solutions, and FightScout. Making software people actually love." />
        <meta property="og:image" content="https://fidweb.net/2025/hero/images/hero-preview.png" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://fidweb.net/2025" />
        <meta name="twitter:title" content="Fidweb 2025 - Our Projects Showcase" />
        <meta name="twitter:description" content="Discover Fidweb's 2025 portfolio: Atletica Sports, Scoutify, Immotech, Amarant, EnRPi, Insurance solutions, and FightScout. Making software people actually love." />
        <meta name="twitter:image" content="https://fidweb.net/2025/hero/images/hero-preview.png" />
      </Helmet>
      
      <div className="christmas-2025-container">
        {/* Wave decoration - positioned behind ERP and Atletica sections */}
        <div className="wave-decoration">
          <img src={waveDecoration} alt="" />
        </div>
        
        <Hero />
        <Atletica />
        {isMobile ? <ScoutifyMobile /> : <Scoutify />}
        {isMobile ? <ImmotechMobile /> : <Immotech />}
        <Amarant />
        <EnRPi />
        <Insurance />
        <FightScout />
        <About />
      </div>
    </>
  );
}

export default Christmas2025;
